import { SERVICES } from "../data/content";

export default function Marquee() {
  const doubled = [...SERVICES, ...SERVICES];
  return (
    <div
      data-testid="services-marquee"
      className="relative overflow-hidden border-y border-white/10 bg-navy-deep py-6"
    >
      <div
        aria-hidden
        className="pointer-events-none absolute inset-y-0 left-0 z-10 w-28 bg-gradient-to-r from-navy-deep to-transparent"
      />
      <div
        aria-hidden
        className="pointer-events-none absolute inset-y-0 right-0 z-10 w-28 bg-gradient-to-l from-navy-deep to-transparent"
      />
      <div
        className="marquee-track flex w-max animate-marquee items-center"
        style={{ animationDuration: "42s" }}
      >
        {doubled.map((s, i) => (
          <span key={i} className="flex items-center">
            <span
              className={`whitespace-nowrap ${
                i % 2 === 0
                  ? "font-serif text-lg italic text-ember"
                  : "font-mono text-[11px] uppercase tracking-[0.32em] text-toothcyan/70"
              }`}
            >
              {s.name}
            </span>
            <svg
              aria-hidden
              className="mx-8 h-3 w-3 animate-spin-slow text-ember drop-shadow-[0_0_7px_rgba(232,178,92,0.8)]"
              viewBox="0 0 10 10"
              fill="currentColor"
            >
              <path d="M5 0L6.5 3.5L10 5L6.5 6.5L5 10L3.5 6.5L0 5L3.5 3.5Z" />
            </svg>
          </span>
        ))}
      </div>
    </div>
  );
}
